import { render, staticRenderFns } from "./testall.vue?vue&type=template&id=49cc1df1&"
import script from "./testall.vue?vue&type=script&lang=js&"
export * from "./testall.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports